<div class="password-recovery-container {{!useOtp && currentStep?.number === 2 ? '!py-8' : ''}}">
	<div class="login-holder">
		<div>
			<div *ngIf="currentStep.number < 3" [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="align-center"
				 nz-row>
				<ng-container *ngIf="currentStep.number !== 5">
					<div [nzSpan]="currentStep.number < 5 ? 18 : 24" class="gutter-row" nz-col>
						<h2 class="stepper-title">{{currentStep?.title}}</h2>
						<div class="stepper-description">{{currentStep?.description}}</div>
					</div>
				</ng-container>
				<div [nzSpan]="currentStep.number < 5? 6 : 0" class="gutter-row" nz-col>
					<div class="stepper-progress-container">
						<nz-progress [nzFormat]="progressText" [nzPercent]="getCurrentStepProgress()"
									 [nzStrokeWidth]="10"
									 [nzWidth]="67" nzStrokeColor="#0361F0" nzStrokeLinecap="round"
									 nzType="circle">
						</nz-progress>
						<ng-template #progressText>
							<div class="progress-text">
								<span><span class="active-step">{{currentStep.number}}</span><span
									class="total-step">/{{stepsArray.length}}</span></span>
							</div>
						</ng-template>
					</div>
				</div>
			</div>
			<div>
				<ng-container [ngSwitch]="currentStep?.number" class="step-container height-120">
					<ng-container *ngSwitchCase="1">
						<app-username-collection (continue)="proceed($event)" [step]="stepsArray[0]">
						</app-username-collection>
					</ng-container>
					<ng-container *ngSwitchCase="2">
						<app-password-otp-validation (back)="goBack()" (continue)="proceed($event)"
													 [step]="stepsArray[1]" [stepsArray]="stepsArray"
													 [useOtp]="useOtp" [identityProvider]="identityProvider"
													 [livelinessCheckReference]="livelinessCheckReference">
						</app-password-otp-validation>
					</ng-container>
					<ng-container *ngSwitchCase="3">
						<app-face-validation (back)="goBack()" (continue)="proceed($event)"
											 [step]="stepsArray[1]" [stepsArray]="stepsArray"></app-face-validation>
					</ng-container>
					<ng-container *ngSwitchCase="4">
						<div class="">
							<h2>You've got mail!</h2>
							<p>
								An email was sent to you, Please follow the link in
								the email we sent you to reset your password
							</p>
						</div>
						<div class="m-t-20" nz-col>
							<app-kamona-custom-button
								[isBlock]='true' [routerLink]="'/login'"
								text='Continue to Login'>
							</app-kamona-custom-button>
						</div>

					</ng-container>

					<ng-container>
						<!-- password change -->
					</ng-container>
				</ng-container>
			</div>
		</div>
	</div>
	<ng-container *ngIf="showFaceCapture">

	</ng-container>
</div>
